import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-8" }

import { useRouter } from 'vue-router'

import { Description } from '@/popup/components/shared/Form/Form'
import Button from '@/popup/components/shared/Button.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Label from '@/popup/components/shared/Form/Label.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  setup(__props) {

const router = useRouter()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Label, {
      "extra-class": "is-title mb-2",
      label: _ctx.$t('authenticate.password.label')
    }, null, 8 /* PROPS */, ["label"]),
    _createVNode(_unref(Description), {
      description: _ctx.$t('settings.password.description')
    }, null, 8 /* PROPS */, ["description"]),
    _createVNode(Button, {
      variant: "secondary",
      "is-full-width": true,
      "custom-class": "items-center",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (
        _unref(router).push({
          path: '/settings/password/change',
          name: 'changeExistingPassword',
        })
      ))
    }, {
      default: _withCtx(() => [
        _createVNode(SvgIcon, {
          class: "mr-2",
          name: "locked"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.password.button_text')), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})